import {
  editClientReport,
  getClientReports,
} from 'api/generated/client-reports/client-reports';
import {
  assignReportToUser as assignReportToUserRequest,
  getReportAssignedUsers,
  unassignReportFromUser as unassignReportFromUserRequest,
} from 'api/generated/report-users/report-users';
import type { ClientReportRequest, GetClientReportsParams } from 'api/generated/schemas';

interface ClientReportsArgs {
  userId: string | number;
  clientId: string | number;
  productId?: string | number;
}

interface ReportUsersArgs {
  userId: string | number;
  reportId: string | number;
  clientId: string | number;
}

interface UpdateReportAccessArgs {
  userId: string | number;
  clientId: string | number;
  reportId: string | number;
  value: {
    userAssignmentStatus: string;
    hasDataIssue: boolean;
  };
}

interface ReportUserAccessArgs {
  userId: string | number;
  reportId: string | number;
  id: string | number;
}

export const fetchClientReports = async ({
  userId,
  clientId,
  productId,
}: ClientReportsArgs): Promise<unknown> => {
  const params: GetClientReportsParams | undefined =
    productId !== undefined && productId !== ''
      ? { 'productId.equals': Number(productId) }
      : undefined;

  return getClientReports(String(userId), Number(clientId), params);
};

export const fetchReportUsers = async ({
  userId,
  reportId,
  clientId,
}: ReportUsersArgs): Promise<unknown> =>
  getReportAssignedUsers(String(userId), Number(reportId), {
    'clientId.equals': Number(clientId),
  });

export const updateReportAccess = async ({
  userId,
  clientId,
  reportId,
  value,
}: UpdateReportAccessArgs): Promise<unknown> =>
  editClientReport(
    String(userId),
    Number(clientId),
    Number(reportId),
    value as ClientReportRequest,
  );

export const assignReportToUser = async ({
  userId,
  reportId,
  id,
}: ReportUserAccessArgs): Promise<unknown> =>
  assignReportToUserRequest(
    String(userId),
    Number(reportId),
    Number(id),
  );

export const unassignReportFromUser = async ({
  userId,
  reportId,
  id,
}: ReportUserAccessArgs): Promise<unknown> =>
  unassignReportFromUserRequest(
    String(userId),
    Number(reportId),
    Number(id),
  );
